import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { ShoppingCart } from "lucide-react";
import "./Navbar.css";

const API_BASE = process.env.REACT_APP_API || "https://cracker-backend-b8ff.onrender.com/api";

function Navbar({ cartItemCount, onCartClick }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")) || null; } 
    catch { return null; }
  });

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showSignup, setShowSignup] = useState(false);
  const [showSignin, setShowSignin] = useState(false);
  const [signupData, setSignupData] = useState({
    name: "", phone: "", email: "", place: "", district: "", password: "", confirmPassword: "",
  });
  const [signinPhone, setSigninPhone] = useState("");
  const [signinPassword, setSigninPassword] = useState("");
  const dropdownRef = useRef(null);

  const handleSignupSubmit = async (e) => {
    e.preventDefault();
    if (signupData.password !== signupData.confirmPassword) return alert("Passwords do not match!");
    try {
      const res = await fetch(`${API_BASE}/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(signupData),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        alert("✅ Signup successful! Please sign in.");
        setShowSignup(false);
        setShowSignin(true);
        setSignupData({ name: "", phone: "", email: "", place: "", district: "", password: "", confirmPassword: "" });
      } else alert(data.message || "Signup failed.");
    } catch (err) {
      console.error("Signup Error:", err);
      alert("Signup failed. Server error.");
    }
  };

  const handleSigninSubmit = async () => {
    if (!signinPhone || !signinPassword) return alert("Please enter email/phone and password");
    try {
      const res = await fetch(`${API_BASE}/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phoneOrEmail: signinPhone, password: signinPassword }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        localStorage.setItem("user", JSON.stringify(data.user));
        setUser(data.user);
        setSigninPhone("");
        setSigninPassword("");
        setShowSignin(false);
        alert("✅ Signed in successfully!");
      } else {
        setSigninPhone("");
        setSigninPassword("");
        alert(data.message || "Signin failed");
      }
    } catch (err) {
      console.error("Signin Error:", err);
      setSigninPhone("");
      setSigninPassword("");
      alert("❌ Failed to contact server. Check if API is running.");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
    setDropdownOpen(false);
    alert("Logged out.");
  };

  return (
    <>
      <nav className="navbar">
        <Link to="/" className="logo">Sri Pathrakali Crackers</Link>
        <div className="nav-links">
          <Link to="/products">Products</Link>
          <Link to="/about">About</Link>
          <button className="cart-button" onClick={onCartClick}>
            <ShoppingCart size={22} />
            <span style={{ marginLeft: 6 }}>{cartItemCount}</span>
          </button>

          <div className="auth-section" ref={dropdownRef}>
            {user ? (
              <div style={{ position: "relative" }}>
                <div onClick={() => setDropdownOpen(v => !v)} className="avatar" title={user.name || user.phone}>
                  {user.name ? user.name.charAt(0).toUpperCase() : "?"}
                </div>
                {dropdownOpen && (
                  <div className="dropdown">
                    <div className="dropdown-info">
                      <div className="dropdown-name">{user.name}</div>
                      <div className="dropdown-email">{user.phone}</div>
                      <div className="dropdown-email">{user.email}</div>
                    </div>
                    <hr />
                    <button onClick={handleLogout} className="logout-btn">Logout</button>
                  </div>
                )}
              </div>
            ) : (
              <>
                <button className="auth-btn" onClick={() => setShowSignup(true)}>Sign Up</button>
                <button className="auth-btn secondary" onClick={() => { 
                  setSigninPhone(""); 
                  setSigninPassword(""); 
                  setShowSignin(true); 
                }}>Sign In</button>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Signup Modal */}
      {showSignup && (
        <div className="modal">
          <div className="modal-content">
            <h2>Sign Up</h2>
            <form onSubmit={handleSignupSubmit}>
              {["name","phone","email","place","district","password","confirmPassword"].map(field => (
                <input
                  key={field}
                  required
                  placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                  type={field.includes("password") ? "password" : "text"}
                  value={signupData[field]}
                  onChange={(e) => setSignupData({ ...signupData, [field]: e.target.value })}
                />
              ))}
              <button type="submit" className="modal-btn">Submit</button>
            </form>
            <button className="close-btn" onClick={() => setShowSignup(false)}>✖</button>
          </div>
        </div>
      )}

      {/* Signin Modal */}
      {showSignin && (
        <div className="modal">
          <div className="modal-content">
            <h2>Sign In</h2>
            <input
              placeholder="Email or Phone"
              value={signinPhone}
              onChange={(e) => setSigninPhone(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={signinPassword}
              onChange={(e) => setSigninPassword(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSigninSubmit()}
            />
            <button onClick={handleSigninSubmit} className="modal-btn">Sign In</button>
            <button className="close-btn" onClick={() => setShowSignin(false)}>✖</button>
          </div>
        </div>
      )}
    </>
  );
}

export default Navbar;
